import React from 'react';

export const TooltipContext = React.createContext({});

export const TooltipProvider = ({ children }) => {
  const hideActiveTooltipRef = React.useRef(() => {});
  const [tooltipDisabled, setTooltipDisabled] = React.useState(false);
  const [dropdownVisible, setDropdownVisible] = React.useState(false);

  const value = React.useMemo(
    () => ({
      setHideActiveTooltip: (fn) => {
        hideActiveTooltipRef.current = fn;
      },
      hideActiveTooltip: () => hideActiveTooltipRef.current(),
      tooltipDisabled,
      setTooltipDisabled,
      dropdownVisible,
      setDropdownVisible,
    }),
    [tooltipDisabled, dropdownVisible],
  );

  return (
    <TooltipContext.Provider value={value}>{children}</TooltipContext.Provider>
  );
};
